<template>
    <section>
        <div id="related-item" class="modal-mask" key="relatedItem" v-if="Object.keys(facturation).length > 0">
            <div class="modal-wrapper _modalWrapper_">
                <div class="modal-container flexContainer">
                    <div class="modalBody">
                        <h2 class="listTitle ff-medium uppercase txtCenter">{{ $t("abonnement.title") }}</h2>
                        <div class="">
                            <div class="form-group row">
                                <label for="example-text-input" class="col-2 col-form-label">{{ $t("abonnement.brand") }}</label>
                                <div class="col-3 bold uppercase" v-if="facturation.brand.hasOwnProperty('name')">{{ facturation.brand.name }}</div>
                            </div>
                            <br />
                            <div class="form-group row">
                                <label for="example-text-input" class="col-2 col-form-label">{{ $t("abonnement.application") }}</label>
                                <div class="col-8">
                                    <div v-for="(n, index) in facturation.applications">
                                        <span class="bold">{{ n.trans.name[$t("trad")] }}</span> <br />{{ $t("abonnement.startSub") }} :
                                        <span class="bold">{{ n.start }}</span
                                        >&nbsp;&nbsp;>&nbsp;&nbsp;{{ $t("abonnement.endSub") }} : <span class="bold">{{ n.end }}</span>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div class="form-group row">
                                <label for="example-text-input" class="col-8 col-form-label">{{ $t("abonnement.nbUser") }}</label>
                                <div class="col-4 bold" style="color: red;">{{ facturation.users }}</div>
                            </div>
                            <br />
                            <div class="form-group row">
                                <label for="example-text-input" class="col-8 col-form-label"
                                    >{{ $t("abonnement.nbModule") }}
                                    <span
                                        v-for="(n, index) in facturation.applications"
                                        v-if="n.trans.name[$t('trad')] === 'catalogue' || n.trans.name[$t('trad')] === 'catalog'"
                                        >{{ n.start }}</span
                                    ></label
                                >
                                <div class="col-4 bold" style="color: red;">{{ facturation.modules }}</div>
                            </div>
                            <br />
                            <div class="form-group row">
                                <label for="example-text-input" class="col-8 col-form-label"
                                    >{{ $t("abonnement.nbProduct") }}
                                    <span
                                        v-for="(n, index) in facturation.applications"
                                        v-if="n.trans.name[$t('trad')] === 'catalogue' || n.trans.name[$t('trad')] === 'catalog'"
                                        >{{ n.start }}</span
                                    ></label
                                >
                                <div class="col-4 bold" style="color: red;">{{ facturation.products }}</div>
                            </div>
                            <br />
                            <div class="form-group row">
                                <label for="example-text-input" class="col-8 col-form-label"
                                    >{{ $t("abonnement.nbShade") }}
                                    <span
                                        v-for="(n, index) in facturation.applications"
                                        v-if="n.trans.name[$t('trad')] === 'catalogue' || n.trans.name[$t('trad')] === 'catalog'"
                                        >{{ n.start }}</span
                                    ></label
                                >
                                <div class="col-4 bold" style="color: red;">{{ facturation.shades }}</div>
                            </div>
                            <br />
                            <div class="form-group row">
                                <label for="example-text-input" class="col-3 col-form-label">{{ $t("abonnement.diffusion") }}</label>
                                <div class="col-8">
                                    <div v-for="(n, index) in facturation.notification" class="flexContainer italic">
                                        {{ n.firstbame }}&nbsp;<span>{{ n.lastname }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="flexContainer fright">
                            <button class="btn uppercase" @click="close();">{{ $t("abonnement.close") }}</button>
                            <button class="btn uppercase" style="margin-left: 10px;" @click="openDiffusion();">
                                {{ $t("abonnement.maintainDiffusion") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Diffusion v-if="diffusion" @hideDiffusionModal="modalClose($event);"></Diffusion>
        </div>
    </section>
</template>

<script>
//    import Vue from 'vue'
import "whatwg-fetch";
import Diffusion from "./Diffusion";
import httpService from "../../components/service";

export default {
    components: {
        Diffusion
    },
    data() {
        return {
            application: [{ name: "Catalogue" }, { name: "Planogramme" }, { name: "Book PDF Catalogue" }],
            diffusion: false,
            facturation: {}
        };
    },
    props: {},
    watch: {},
    methods: {
        modalClose(close) {
            this.diffusion = close;
        },
        openDiffusion() {
            this.diffusion = true;
        },
        close() {
            this.$emit("hideAbonnementModal");
        }
    },
    computed: {},
    created() {
        httpService.get("/admin/subscription/detail").then(response => {
            this.facturation = response;
        });
    }
};
</script>

<style lang="scss" scoped>
._selectedCampaign,
._selectedZone {
    color: #0000f0;
    font-weight: bold;
}
/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}
/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 50px;
        right: 50px;
        z-index: 2;
    }
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            margin: auto;
            .brandWrap {
                padding: 5px;
            }
            p {
                font-family: Roboto;
                font-size: 18px;
            }
            .swiper-container-horizontal {
                .swiper-pagination {
                    margin-top: 10px;
                    position: initial;
                }
            }
            .swiper-button-prev {
                left: 25%;
                height: 15px;
            }
            .swiper-button-next {
                right: 25%;
                height: 15px;
            }
        }
    }
}
#zone {
    .brandLogo {
        margin: auto;
        line-height: 110px;
    }
}
#campaign {
    .brandLogo {
        margin: auto;
        line-height: 110px;
    }
}
#related-item {
    .modalBody {
        h2 {
            margin-top: 0px;
        }
        #selectContainer {
            margin-bottom: 30px;
        }
        width: 650px;
        min-height: 200px;
        background: #fff;
        border-radius: 4px;
        padding: 30px;
        #filterCategory {
            margin-top: 30px;
            margin-bottom: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Abonnement.vue?7ab73353